<template>
  <v-card class="mt-5" v-if="vlogList.length">
    <div class="d-flex align-center px-5 pt-3">
      <h2 class="drawer-right__title my-0 font-weight-bold">
        <translate>Latest VLOG</translate>
      </h2>
      <router-link
        :to="linkToVlog()"
        @click.native="scrollToTop"
        class="ml-auto primary--text subtitle-2 pointer"
        ><translate>See all</translate>
        <v-icon size="20" color="primary" class="ml-1"
          >fal fa-angle-right</v-icon
        >
      </router-link>
    </div>
    <v-list-item 
      three-line class="d-block lastVlog"
      v-for="(vlog, index) in vlogList" 
      :key="index" 
    >
      <v-list-item-content 
        v-if="vlog.media.length !== 0" 
        class="lastVlog__content"
      >
        <VideoThumb
          :srcThumb="vlog.media[vlog.media.length - 1].thumbnail"
          :indexThumb="index"
          :meta="metaObj(vlog.media[vlog.media.length - 1].meta)"
          :vlog="vlog"
          :isLinkToDetailPost="true"
          @linkToDetailPost="linkToDetailPost"
        />
      </v-list-item-content>
      <v-divider class="mt-3" v-if="index !== vlogList.length - 1"></v-divider>
    </v-list-item>
  </v-card>
</template>
<script>
import VideoThumb from "@/components/Thumbnails/VideoThumb";
import PhotoThumb from "@/components/Thumbnails/PhotoThumb";
import PostService from "@/services/PostService";
export default {
  data() {
    return {
      vlogList: []
    };
  },
  components: { VideoThumb, PhotoThumb },
  computed: {
    courseDetail() {
      return this.$store.state.golfcourse.courseDetail;
    }
  },
  watch: {
    courseDetail: {
      immediate: true,
      handler(val) {
        if (val.id) {
          this.getCourseVlogList(val.id);
        } else {
          this.getListData();
        }
      }
    }
  },
  methods: {
    linkToVlog() {
      if (this.courseDetail && Object.keys(this.courseDetail).length === 0 && this.courseDetail.constructor === Object) {
         return {
          name: 'coaches'
        }
      }
      else {
        return {
          name: 'courses.vlog'
        }
      }
    },
    async getListData(page = 1, limit = 3, type = POST_TYPE_VLOG) {
      const vlog = await PostService.getPostList({
        filter_type: [type],
        sort_desc: "createdDate",
        page,
        limit
      });
      if (vlog && !vlog.error) {
        let listMedia = [];
        for (let item of vlog.list) {
          if (item.media && item.media.length) {
            listMedia.push(item);
          }
          // stop loop
          if (listMedia.length > 2) {
            break;
          }
        }
        this.vlogList = listMedia;
      }
    },
    async getCourseVlogList(id) {
      const vlog = await this.$store.dispatch("post/getPostVlog", {
        id: id,
        page: 1,
        limit: 10
      });
      if (vlog && !vlog.error) {
        let listMedia = [];
        for (let item of vlog.list) {
          if (item.media && item.media.length) {
            listMedia.push(item);
          }
          // stop loop
          if (listMedia.length > 2) {
            break;
          }
        }
        this.vlogList = listMedia;
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    metaObj(meta) {
      const res = Array.isArray(meta) ? {} : meta;
      return res;
    },
    linkToDetailPost(id) {
      this.$router.push({name: 'postDetail', params: {id}})
    }
  }
};
</script>
